import React, { useContext, useEffect, useState } from 'react'
import PageHead from '../../Components/PageHead'
import Tab from '../../Components/Tab';
import { formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY, getTypeWatchDelay, LogInSchoolID, typewatch } from '../../JS/Common';
import { ApiGetCall } from '../../JS/Connector';
import Pagination from 'react-js-pagination';
import Popup from '../../Components/Popup';
import useConfig from '../../Hooks/useConfig';

export default function History() {
    const { student, students } = useConfig();
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [SortbyKey, setSortbyKey] = useState(null);
    const [UncoveredPopup, setUncoveredPopup] = useState(false);
    const [Tabs, setTabs] = useState({
        RefundHistory: "active",
        CoverageHistory: ""
    })
    const [AllData, setAllData] = useState({
        searchstringForRefund: "",
        searchstringForCoverage: "",
        SortbyFlag: "asc"
    })
    const [GridData, setGridData] = useState([]);
    const [PlanData, setPlanData] = useState({});
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const showPagination = GridData?.length > 0;
    const itemsPerPage = LimitForPagination;
    useEffect(() => {
        if (Tabs.RefundHistory == "active") {
            GetData(1, AllData.searchstringForRefund || null, SortbyKey || null, false)
        } else {
            GetData(2, AllData.searchstringForCoverage || null, SortbyKey || null, false)
        }
    }, [currentPage, LimitForPagination])
    function GetData(tabflag, searchstring, sortbykey, toogleSort) {
        if (!searchstring) searchstring = null;
        if (sortbykey) {
            if (toogleSort) AllData.SortbyFlag = AllData.SortbyFlag == "asc" ? "desc" : "asc";
        }
        else {
            sortbykey = 'id';
        }
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/plans/insurance/history?flag=${tabflag}&schoolId=${LogInSchoolID}&search=${searchstring}&sortBy=${sortbykey}&sortByOrder=${AllData.SortbyFlag}&page=${currentPage}&limit=${LimitForPagination}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false);
                    setGridData(responseRs?.data?.length ? responseRs?.data : [])
                    setpageRangeCount(responseRs?.total)
                }
            });
        }, getTypeWatchDelay(searchstring, 1000));
    }
    function handleSearchChange(e) {
        if (Tabs.RefundHistory == "active") {
            setCurrentPage(1);
            GetData(1, e.target.value, null, false);
            setAllData({ ...AllData, searchstringForRefund: e.target.value });
        } else {
            setCurrentPage(1);
            GetData(2, e.target.value, null, false);
            setAllData({ ...AllData, searchstringForCoverage: e.target.value });
        }
    }
    function handleTabClick(tabType) {
        setGridData([]);
        if (tabType == "refund") {
            GetData(1, null, null, false);
            setTabs({ ...Tabs, RefundHistory: "active", CoverageHistory: "" });
            setCurrentPage(1);
        } else if (tabType == "covered") {
            GetData(2, null, null, false);
            setTabs({ ...Tabs, RefundHistory: "", CoverageHistory: "active", });
            setCurrentPage(1);
        }
    }
    const handleSortClick = (item) => {
        if (item !== 0) {
            if (Tabs.RefundHistory == "active") {
                GetData(1, AllData.searchstringForRefund, item, true)
            } else {
                GetData(2, AllData.searchstringForCoverage, item, true)
            }
            setSortbyKey(item)
        }
    };
    const modalbody = (
        <div className='row'>
            <div className='col-12'>
                {student} num : <b>{PlanData?.student?.student_num}</b>
            </div>
            <div className='col-12'>
                {student} Name : <b>{PlanData?.student?.device_user_first_name} {PlanData?.student?.device_user_last_name}</b>
            </div>
            <div className='col-12 pb-2'>
                Unenrolled to Enrolled date : <b>{PlanData?.uncovered_to_covered_date ? formatDateToMMDDYYYY(PlanData?.uncovered_to_covered_date) : '-'}</b>
            </div>
            <hr />
            <b>Unenrolled Club : </b>
            <div className='col-12 py-1'>
                Club Name : <b>{PlanData.old_allocation}</b>
            </div>
            <div className='col-12 py-1'>
                Sign Up Start Date : <b>{PlanData.old_allocation_sign_up_date ? formatDateToMMDDYYYY(PlanData.old_allocation_sign_up_date) : '-'}</b>
            </div>
            <div className='col-12 py-1'>
                Paid Amount : <b>$0</b>
            </div>
            <div className='col-12 pt-1 pb-3'>
                Grade : <b>{PlanData.old_allocation_grade}</b>
            </div>
            <hr />
            <b>Enrolled Club :</b>
            <div className='col-12 py-1'>
                Club Name : <b>{PlanData.new_allocation}</b>
            </div>
            <div className='col-12 py-1'>
                Sign Up Start Date : <b>{PlanData.new_allocation_sign_up_date ? formatDateToMMDDYYYY(PlanData.new_allocation_sign_up_date) : '-'}</b>
            </div>
            <div className='col-12 py-1'>
                Paid Amount : <b>${PlanData.new_allocation_paid_amount}</b>
            </div>
            <div className='col-12 py-1'>
                Grade : <b>{PlanData.new_allocation_grade}</b>
            </div>
        </div>
    )
    return (
        <React.Fragment>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Club History"} handleSearch={handleSearchChange}
                loading={loading} showsearch={true} />
            <div className="GridBox mt-2 p-3">
                <div className="row px-0 pb-2">
                    <div className='col-md-12'>
                        <ul className="nav nav-tabs">
                            <Tab isActive={Tabs.RefundHistory == 'active'}
                                label={`Purchases Refunded`} onClick={() => handleTabClick('refund')} col={'col-md-3'} />
                            <Tab isActive={Tabs.CoverageHistory == 'active'}
                                label="Unenrolled to Enrolled" onClick={() => handleTabClick('covered')} col={'col-md-3'} />
                        </ul>
                    </div>
                </div>
                <div className="greyBox p-3 data-table-container">
                    <table className="table data-table">
                        <thead className='GridHeader'>
                            <tr>
                                <th scope="col" className='cursor-pointer fw-600' title={"Sort by User ID"} onClick={(e) => handleSortClick('student_num')}>
                                    User ID<img src="/images/sortbynew.svg" className="img-fluid ps-2 sortbyClass" />
                                </th>
                                <th scope="col" className='cursor-pointer fw-600' title={`Sort by  ${student} Name`} onClick={(e) => handleSortClick(Tabs.RefundHistory == "active" ? 'student_name' : 'device_user_first_name')}>
                                    {student} Name<img src="/images/sortbynew.svg" className="img-fluid ps-2 sortbyClass" />
                                </th>
                                <th scope="col" className='cursor-pointer fw-600' title={`Sort by Club Name`} onClick={(e) => handleSortClick('plan_name')}>
                                    Club Name<img src="/images/sortbynew.svg" className="img-fluid ps-2 sortbyClass" />
                                </th>
                                <th scope="col" className='cursor-pointer fw-600' title={`Sort by Paid Amount`} onClick={(e) => handleSortClick('paid_amount')}>
                                    Paid Amount<img src="/images/sortbynew.svg" className="img-fluid ps-2 sortbyClass" />
                                </th>
                                <th scope="col" className='cursor-pointer fw-600' title={`Sort by Grade`} onClick={(e) => handleSortClick('grade')}>
                                    Grade<img src="/images/sortbynew.svg" className="img-fluid ps-2 sortbyClass" />
                                </th>
                                {Tabs.RefundHistory == "active" && (
                                    <th scope="col" className='fw-600'>
                                        Refunded Date
                                    </th>
                                )}
                                {Tabs.CoverageHistory == "active" && (
                                    <th scope="col" className='fw-600'>
                                        Action
                                    </th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {GridData?.length != 0 ?
                                GridData?.map((item, i) => {
                                    return <tr key={i} className="OddEvenClass tableBorderHide">
                                        {Tabs.CoverageHistory == "active" ?
                                            <>
                                                <td className="py-12">
                                                    {item.student?.student_num}
                                                </td>
                                                <td className="py-12">
                                                    {item.student?.device_user_first_name} {item.student?.device_user_last_name}
                                                </td>
                                                <td className="py-12">
                                                    {item.new_allocation}
                                                </td>

                                                <td className="py-12">
                                                    ${item.new_allocation_paid_amount}
                                                </td>
                                                <td className="py-12">
                                                    {item.new_allocation_grade}
                                                </td>
                                                <td className='py-12'>
                                                    <img src="/images/InfoIcon.svg" title="Show User History"
                                                        className="img-fluid cursor-pointer px-2"
                                                        onClick={(e) => { setPlanData(item); setUncoveredPopup(true) }} />
                                                </td>
                                            </>
                                            :
                                            <>
                                                <td className="py-12">
                                                    {item.student_num}
                                                </td>
                                                <td className="py-12">
                                                    {item.student_name}
                                                </td>
                                                <td className="py-12">
                                                    {item.oldplan?.plan_name}
                                                </td>
                                                <td className="py-12">
                                                    ${item.paid_amount}
                                                </td>
                                                <td className="py-12">
                                                    {item.grade}
                                                </td>
                                                <td className='py-12'>
                                                    {item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : '-'}
                                                </td>
                                            </>
                                        }
                                    </tr>
                                })
                                :
                                <tr className="text-center">
                                    <td colSpan={15}>No Record Found</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
                {showPagination && (
                    <Pagination
                        activePage={currentPage}
                        itemsCountPerPage={itemsPerPage}
                        totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15}
                        onChange={(e) => setCurrentPage(e)}
                        color="primary"
                        lastPageText=""
                        firstPageText=""
                        itemClassFirst="MasterClass"
                        itemClassPrev="MasterClass"
                        itemClassNext="MasterClass"
                        itemClassLast="MasterClass"
                        hideFirstLastPages={true} />
                )}
            </div>
            <Popup isshow={UncoveredPopup} size={"md"} title={`Unenrolled to Enrolled  ${student}`}
                closePopup={(e) => { setUncoveredPopup(false) }}
                modalBody={modalbody} visibleSaveBtn={false} />
        </React.Fragment>
    )
}
